import YouTubeIcon from '@mui/icons-material/YouTube'
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import { isFlyin } from '@/src/utils/generalUtils/isFlyin'


export const getFooterLinksByBrand = (t: (key: string) => string, locale: string) => {

    // Social media links configuration
    const flyinSocialMediaLinks = [
        {
            name: 'youtube',
            href: 'https://www.youtube.com/user/FlyinVideos',
            icon: YouTubeIcon
        },
        {
            name: 'twitter',
            href: 'https://twitter.com/flyincom',
            icon: 'twitter' // Custom SVG
        },
        {
            name: 'instagram',
            href: 'https://www.instagram.com/flyincom/',
            icon: InstagramIcon
        },
        {
            name: 'facebook',
            href: 'https://www.facebook.com/flyin.com',
            icon: FacebookIcon
        },
        {
            name: 'linkedin',
            href: 'https://www.linkedin.com/company/flyin-com',
            icon: LinkedInIcon
        },
        {
            name: 'threads',
            href: 'https://www.threads.net/@flyincom',
            icon: 'threads'
        }
    ]

    const cleartripSocialMediaLinks = [
        {
            name: 'instagram',
            href: 'https://www.instagram.com/cleartrip_arabia',
            icon: InstagramIcon
        },
        {
            name: 'facebook',
            href: 'https://www.facebook.com/CleartripArabia',
            icon: FacebookIcon
        },
        {
            name: 'linkedin',
            href: 'https://www.linkedin.com/company/cleartrip-arabia',
            icon: LinkedInIcon
        },
    ]
    // Company links
    const flyinCompanyLinks = [
        { label: t('aboutUs'), href: `/aboutUs.${locale}.html`,value : 'aboutUs' },
        { label: t('faqs'), href: `/faqs.${locale}.html`, value : 'faqs' },
        { label: t('privacyPolicy'), href: `/privacyPolicy.${locale}.html`, value : 'privacyPolicy' },
        { label: t('termsOfUse'), href: `/termsOfUse.${locale}.html`, value : 'termsOfUse' }
    ]

    const cleartripCompanyLinks = [
        { label: t('aboutUs'), href: `/about`,value : 'aboutUs' },
        { label: t('faqs'), href: `/faq`, value : 'faqs' },
        { label: t('privacyPolicy'), href: `/privacy`, value : 'privacyPolicy' },
        { label: t('termsOfUse'), href: `/terms`, value : 'termsOfUse' },
    ]

    // Support links
    const flyinSupportLinks = [
        { label: t('flyinWallet'), href: `/${locale}/wallet`,value : 'flyinWallet' },
        { label: t('contactUs'), href: `/${locale}/contact`, value : 'contactUs' },
        {
            label: t('addYourProperty'),
            href: 'https://extranet.flyin.com/?_gl=1*44oyfn*_gcl_au*Njk5NjI3OTgwLjE3NjQ5NDI4Njg.*_ga*ODU1MzYwMTExLjE3NjQ5NDI4Njg.*_ga_TKS3E29Q16*czE3NjQ5NDI4NjgkbzEkZzEkdDE3NjQ5NDMwMjQkajMwJGwwJGg3NDcyMzk5MDY.*_fplc*MmNBTDdMY1B6dGl2Q1pIbXZESG9wTnBFUUp6TEgwcjBsWUR3cGtPT0dodVR3RmYyaVYlMkJTQVNNRVR2ODMlMkJkeFBrdEdMUVlqemdCZkt2dm1rVUhOVENCcDZIJTJCUDB5UGlJTHFwdFJ0Rk1KTzNoUEtMdGwlMkI4eHpDbElPajNBJTJCZyUzRCUzRA..#/hotels/suppliers/edit',
            target: '_blank',
            value: 'addYourProperty'
        },
        { label: 'flyinFranchise', href: `/franchise/joinUs.en.html`, value : 'flyinFranchise' }
    ]

    const cleartripSupportLinks = [
        { label: t('contactUs'), href: `/${locale}/contact`, value : 'contactUs' },
        { label: t('Collections'), href: `/collections`, value : 'collections' },
        { label: t('giftCards'), href: `https://yougotagift.com/shop/en-ae/brands/cleartrip/`, value : 'giftCards' }
    ]

    const cleartripFooterLinks = {
        companyLinks: cleartripCompanyLinks,
        supportLinks: cleartripSupportLinks,
        socialMediaLinks : cleartripSocialMediaLinks
    }
    const flyinFooterLinks = {
        companyLinks: flyinCompanyLinks,
        supportLinks: flyinSupportLinks,
        socialMediaLinks : flyinSocialMediaLinks
    }
    return isFlyin() ? flyinFooterLinks : cleartripFooterLinks;
}

export const getLinkByName = (name: string, type: 'company' | 'support' | 'socialMedia',t :(key: string) => string) => {
    const allLinks = getFooterLinksByBrand(t, 'en');
    switch(type) {
        case 'company':
            return allLinks.companyLinks.find(link => link.value === name)?.href;
        case 'support':
            return allLinks.supportLinks.find(link => link.value === name)?.href;
        case 'socialMedia':
            return allLinks.socialMediaLinks.find(link => link.name === name)?.href;
        default:
            return null;
    }
}
